<script>
    import GiftCardItem from './GiftCardItem.vue'

    export default {
        props: {
            data: Array
        },
        components: {GiftCardItem},
        data() {
            return {
                items: this.data
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/gift/GiftCardsContainer.vue